import ResizeObserver from 'resize-observer-polyfill';
import EmbedScriptEvent from './event/EmbedScriptEvent';
import { processTokenError } from './Utils';
import WidgetEvent from './event/WidgetEvent';

export default class InstanceController {
	constructor(instanceRegistry, authorizationTokenProvider) {
		this._authorizationTokenProvider = authorizationTokenProvider;

		this._authorizationTokenProvider.onStateChange = () => {
			authorizationTokenProvider.lastAuthorizationToken = null;

			this._authorizationTokenProvider.isSignedIn()
				? this._authorizationTokenProvider.getToken((tokenError, token) => {
						authorizationTokenProvider.lastAuthorizationToken = token;
						sendEventToAllInstances(EmbedScriptEvent.LOGIN, { token });
						processTokenError(tokenError);
				  })
				: sendEventToAllInstances(
						EmbedScriptEvent.LOGOUT,
						this._authorizationTokenProvider.getLogoutData()
				  );
		};

		function sendEventToAllInstances(event, payload = {}) {
			const instances = instanceRegistry.getAllInstances();

			instances.forEach(instance => instance.sendEvent(event, payload));
		}

		window.addEventListener('login-close', () => {
			sendEventToAllInstances(EmbedScriptEvent.LOGIN_CLOSE);
		});

		window.addEventListener(WidgetEvent.FORM_CLOSE, ({ detail }) => {
			const instance = instanceRegistry.getInstanceByInstanceId(detail?.sentinel);

			if (instance) {
				instance.widgetFormClosed();
			}
		});

		window.addEventListener(
			WidgetEvent.FORM_POST,
			/**
			 *
			 * @param {CustomEvent} event
			 * @param event.detail
			 * @param {object} event.detail.comment - Data to create new comment
			 * @param {string} event.detail.comment.content
			 * @param {object} event.detail.comment.urlCards
			 * @param {object} event.detail.comment.image
			 * @param {string} event.detail.sentinel - Instance sentinel
			 * @param {object} event.detail.user - To verify active user
			 */
			({ detail }) => {
				const instance = instanceRegistry.getInstanceByInstanceId(
					detail?.sentinel
				);
				if (instance) {
					instance.postComment(detail);
				}
			}
		);

		window.addEventListener('message', ({ data }) => {
			const { type, sentinel, payload } = data;

			const instance = instanceRegistry.getInstanceByInstanceId(sentinel);

			if (instance && typeof instance[type] === 'function') {
				instance[type](payload);
			}
		});
		window.addEventListener('mouseup', () =>
			sendEventToAllInstances(EmbedScriptEvent.HOST_CLICK)
		);

		let lastObservedRect = {};

		this._resizeObserver = new ResizeObserver(entries => {
			if (!(entries[0] && entries[0].contentRect)) {
				return;
			}

			const observedRect = this._destructureDOMRect(entries[0].contentRect);

			if (!this._areClientRectsEqual(lastObservedRect, observedRect)) {
				lastObservedRect = observedRect;

				const instances = instanceRegistry.getAllInstances();
				instances.forEach(instance => instance.handleDocumentResize());
			}
		});

		this._resizeObserver.observe(document.body);
	}

	onNewDiscussionCreated(discussionInstance) {
		if (
			this._authorizationTokenProvider.isSignedIn() &&
			this._authorizationTokenProvider.lastAuthorizationToken
		) {
			discussionInstance.onLoad = () =>
				discussionInstance.sendEvent(EmbedScriptEvent.LOGIN, {
					token: this._authorizationTokenProvider.lastAuthorizationToken
				});
		}
	}

	/**
	 * Returns client rects and return's true if they're the same.
	 *
	 * @param {DOMRectReadOnly} a
	 * @param {DOMRectReadOnly} b
	 * @returns {boolean}
	 */
	_areClientRectsEqual(a, b) {
		return a.height === b.height && a.width === b.width && a.x === b.x && a.y === b.y;
	}

	/**
	 * Returns required properties destructured from given DOMRect
	 *
	 * @param {DOMRectReadOnly} DOMRect
	 * @returns {{ height: number, width: number, x: number, y: number}}
	 */
	_destructureDOMRect(DOMRect) {
		return {
			height: DOMRect.height,
			width: DOMRect.width,
			x: DOMRect.x,
			y: DOMRect.y
		};
	}
}
